export default __webpack_public_path__ + "static/testing-6f8e9f759842dbb56e850eb14c162b8e.jpeg";